import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { CreateUserRequest } from '@/api/handlers/resources/users/requests';
import type { UserWriteResponse } from '@/api/handlers/resources/users/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { UserQueryKeys } from './userQueryKeys';

export const useCreateUserMutation = () => {
    const { apiClient } = useApi();
    const queryClient = useQueryClient();

    return useMutation<
        ApiResponse<UserWriteResponse>,
        Error,
        CreateUserRequest
    >({
        mutationFn: (body) => apiClient.users.createUser(body),
        onSuccess: (result) => {
            if (result.success) {
                queryClient.invalidateQueries({
                    queryKey: UserQueryKeys.all,
                });
            }
        },
    });
};
